<template>
  <div class="warranty-activation-page">
    <!-- 上半部分 -->
    <div class="upper-section">
      <div class="container">
        <div class="content-wrapper">
          <!-- 左侧内容 -->
          <div class="left-content">
            <h2 class="section-title">Warranty</h2>
            <p class="warranty-text">
              This warranty is extended exclusively to the original purchaser and is non-transferable. 
              For any warranty service requests, please provide the original 
              order number or proof of purchase and ensure that the product is within the warranty period.
            </p>
            <div class="button-group">
              <button class="activation-btn email-btn" @click="activateByEmail">
                <i class="bi bi-envelope"></i>
                Email Activation
              </button>
              <button class="activation-btn sms-btn" @click="activateBySMS">
                <i class="bi bi-chat-text"></i>
                SMS Activation
              </button>
            </div>
          </div>
          
          <!-- 右侧图片 -->
          <div class="right-content">
            <img 
              src="@/assets/images/warranty.jpg" 
              alt="Warranty Illustration" 
              class="warranty-image"
            >
          </div>
        </div>
      </div>
    </div>
    
    <div class="container"><hr class="divider"></div>
    
    <!-- 下半部分 -->
    <div class="lower-section">
      <div class="container">
        <h2 class="section-title">What is Covered?</h2>

        <div class="coverage-content">
            <h3>5-Year Limited Warranty</h3>
            <ul class="coverage-list">
                <li>
                <strong>Limited to replacement parts and after-sales support.</strong><br>
                On-site repairs are not available.
                </li>
                <li>
                <strong>New Products Only</strong><br>
                Applies only to new KURPOT products purchased on Amazon. Does not cover used items.
                </li>
                <li>
                <strong>Customized Accessories</strong><br>
                Customized accessories are not covered. Contact us separately for purchase options.
                </li>
                <li>
                <strong>Finding Your Order Number</strong>
                <div><strong>Amazon Orders:</strong> Find your order number in the "Returns & Orders" section of your Amazon account.</div>
                </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarrantyActivation',
  methods: {
    activateByEmail() {
      // 使用mailto协议打开默认邮件客户端
      const email = 'kurpot-us@outlook.com';
      const subject = 'Warranty Activation';
      const body = "Hi KURPOT,\n\nI'm having an issue with the product.\n①Amazon order number(17-digit):\n②Problem description:\n\n③Phone number:\n④Shipping address:\n\n⑤Issue images:\n\n\n**Please make sure that KURPOT emails are not sorted into the spam folder so that you don't miss our reply.";
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },
    
    activateBySMS() {
      // 在移动端打开短信应用
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const phoneNumber = '+12137706133';
        const message = `Hi KURPOT,\nI'm having an issue with the product.\nHere is Amazon order number:\nEmail address:\nProblem description:\nIssue Images:\n`;
        window.location.href = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
      } else {
        this.$message.info('Please use your mobile device to send a text message');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warranty-activation-page {
  min-height: 100vh;
  font-family: 'Gotham', sans-serif;
  text-align: left;
  font-family: 'SupremeLLSub-Black' !important;

}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.upper-section {
  padding: 60px 0;
  
  .content-wrapper {
    display: flex;
    gap: 40px;
    align-items: center;
    
    @media (max-width: 992px) {
      flex-direction: column;
    }
  }
  
  .left-content {
    flex: 1;
    
    .section-title {
      font-size: 80px;
      font-weight: 800;
      margin-bottom: 20px;
      color: #26333A;
      
      @media (max-width: 1200px) {
        font-size: 60px;
      }
      
      @media (max-width: 992px) {
        font-size: 50px;
        text-align: center;
      }
      
      @media (max-width: 768px) {
        font-size: 40px;
      }
      
      @media (max-width: 576px) {
        font-size: 32px;
      }
    }
    
    .warranty-text {
      font-size: 1rem;
      line-height: 1.6;
      color: #666;
      margin-bottom: 30px;
      
      @media (max-width: 992px) {
        text-align: center;
      }
    }
    
    .button-group {
      display: flex;
      gap: 15px;
      margin-top: 25px;
      
      @media (max-width: 992px) {
        justify-content: center;
      }

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 12px;
      }
    }
  }
  
  .right-content {
    flex: 1;
    display: flex;
    justify-content: center;
    
    .warranty-image {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      
      @media (max-width: 992px) {
        max-width: 80%;
      }
      
      @media (max-width: 768px) {
        max-width: 100%;
      }
    }
  }
}

.activation-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 25px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 180px;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 14px 20px;
    min-width: auto;
  }
  
  @media (max-width: 576px) {
    padding: 12px 16px;
    font-size: 0.9rem;
  }
  
  &.email-btn {
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    color: white;
    box-shadow: 0 3px 12px rgba(37, 211, 102, 0.25);
    
    &:hover {
      background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(37, 211, 102, 0.35);
    }
  }
  
  &.sms-btn {
    background: linear-gradient(135deg, #007AFF 0%, #0055FF 100%);
    color: white;
    box-shadow: 0 3px 12px rgba(0, 122, 255, 0.25);
    
    &:hover {
      background: linear-gradient(135deg, #0055FF 0%, #0040CC 100%);
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 122, 255, 0.35);
    }
  }
  
  i {
    font-size: 1.1rem;
  }
}

.lower-section {
  padding: 60px 0;
  
  @media (max-width: 768px) {
    padding: 40px 0;
  }
  
  .section-title {
    font-size: 50px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #26333A;
    
    @media (max-width: 992px) {
      text-align: center;
    }
    
    @media (max-width: 768px) {
      font-size: 36px;
    }
    
    @media (max-width: 576px) {
      font-size: 28px;
    }
  }
  
  .coverage-content {
    margin-bottom: 40px;
    
    @media (max-width: 992px) {
      text-align: center;
    }
    
    h3 {
      font-size: 1.4rem;
      margin-bottom: 20px;
      color: #000;
      
      @media (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    
    p {
      font-size: 1rem;
      line-height: 1.6;
      color: #666;
      margin-bottom: 20px;
    }
    
    .coverage-list {
      list-style-type: none;
      padding-left: 0;
      
      @media (max-width: 992px) {
        text-align: left;
        margin: 0 auto;
        max-width: 600px;
      }
      
      li {
        margin-bottom: 15px;
        line-height: 2;
        color: #666;
        
        strong {
          color: #000;
        }
        
        .nested-item {
          margin-left: 0;
          padding-left: 1em;
          position: relative;
          
          &:before {
            content: "•";
            position: absolute;
            left: 0;
          }
        }
      }
    }
  }
}

.divider {
  margin: 40px 0;
  border: 0;
  height: 1px;
  background: #eee;
  
  @media (max-width: 768px) {
    margin: 30px 0;
  }
}
</style>